import elTableInfiniteScroll from './el-table-infinite-scroll'

elTableInfiniteScroll.install = (Vue) => {
  Vue.directive('el-table-infinite-scroll', elTableInfiniteScroll)
}

export default elTableInfiniteScroll
